var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m600 287.12c-11.652-30-26.531-55.68-43.789-77.496l-185.82 50.641 230.59 62.953-230.59 62.867 230.59 62.988-230.59 63.023 230.59 62.832-230.59 62.953 230.59 62.844-230.59 62.953 230.59 62.879-182.77 49.812c15.215 12.758 30.059 25.488 44.316 38.184l138.46 37.801-77.184 21.082c34.906 37.105 62.113 74.52 76.211 113.11l0.023437 0.023437v-0.023437c63.719-174.41 394.61-324.52 497.64-530.79 199.36-398.66-362.73-616.07-497.68-268.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.53 914.55c22.055 19.621 42.77 39.238 61.262 58.871l77.184-21.059z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1100.3 252.39c-52.5-84.969-153.45-139.86-257.16-139.86-109.15 0-197.12 57.539-243.12 158.4-45.996-100.86-133.96-158.4-243.14-158.4-103.69 0-204.64 54.887-257.14 139.86-53.879 87.18-52.922 196.44 2.6758 307.64 51.539 103.07 158.26 190.74 261.47 275.53 101.75 83.629 197.88 162.64 228.52 246.59 1.1758 3.1914 4.2344 5.3047 7.6211 5.3047h0.011719c3.3477 0 6.4062-2.125 7.5859-5.3047 30.648-83.902 126.76-162.91 228.52-246.56 103.25-84.816 209.98-172.55 261.47-275.55 55.652-111.25 56.613-220.5 2.6992-307.65zm-743.4-123.65c108.76 0 194.64 60.504 235.59 165.96 2.3281 6.1211 12.805 6.0586 15.098 0.023438 40.957-105.48 126.83-165.98 235.6-165.98 98.207 0 193.75 51.875 243.34 132.19 50.82 82.246 49.645 185.88-3.3359 291.86-50.027 100.02-155.39 186.56-257.36 270.35-96.383 79.246-187.68 154.25-225.76 235.25-38.09-81.059-129.38-156.11-225.83-235.34-101.93-83.746-207.29-170.32-257.26-270.25-52.992-105.98-54.203-209.64-3.3711-291.85 49.582-80.332 145.11-132.2 243.3-132.2z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/qatar.ed65091327aeea6f3fa992c43d55bf7a.svg";
export { ForwardRef as ReactComponent };